import { render, staticRenderFns } from "./Reserved.vue?vue&type=template&id=1fb30ff9&scoped=true&lang=pug&"
import script from "./Reserved.vue?vue&type=script&lang=js&"
export * from "./Reserved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb30ff9",
  null
  
)

export default component.exports